import AsyncStorage from '@react-native-async-storage/async-storage';
import {Platform} from 'react-native';

/**
 * Load the last state from AsyncStorage (React Native) or localStorage (Web)
 * Only loads on web since AsyncStorage is async on React Native
 */
export const loadLastState = (): {gdata?: any} | undefined => {
  try {
    let serializedState: string | null = null;
    if (Platform.OS === 'web') {
      serializedState = localStorage.getItem('authData');
    } else {
      // For React Native, AsyncStorage is async, so we'll return undefined
      // and handle loading in the subscribe callback
      return undefined;
    }
    if (serializedState === null) {
      return undefined;
    }
    return {gdata: JSON.parse(serializedState)};
  } catch (err) {
    console.error('Could not load state:', err);
    return undefined;
  }
};

/**
 * Save state to storage
 */
export const saveState = async (state: any): Promise<void> => {
  try {
    const {gdata} = state; // Extract only the `auth` state
    const serializedState = JSON.stringify(gdata);
    if (Platform.OS === 'web') {
      localStorage.setItem('authData', serializedState);
    } else {
      await AsyncStorage.setItem('authData', serializedState);
    }
  } catch (err) {
    console.error('Could not save state:', err);
  }
};

